import { render, staticRenderFns } from "./RendersTable.vue?vue&type=template&id=65c1e094"
import script from "./RendersTable.vue?vue&type=script&lang=js"
export * from "./RendersTable.vue?vue&type=script&lang=js"
import style0 from "./RendersTable.vue?vue&type=style&index=0&id=65c1e094&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports